import { render, staticRenderFns } from "./DistributorArticles.vue?vue&type=template&id=bb65b5fa&scoped=true&"
import script from "./DistributorArticles.vue?vue&type=script&lang=js&"
export * from "./DistributorArticles.vue?vue&type=script&lang=js&"
import style0 from "./DistributorArticles.vue?vue&type=style&index=0&id=bb65b5fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb65b5fa",
  null
  
)

export default component.exports